export default {
  login: '/login/:context?',
  forgotPassword: '/forgot-password',
  resetPasswordWithToken: '/reset-password/:token',
  enrollAccount: '/enroll-account/:token',
};
